// These are EU countries that can be found here:
// https://community.cookiepro.com/s/article/UUID-97c0d8a2-cf62-82b6-48e2-2c2bb4ef9c67?topicId=0TO1Q000000ssK9WAI
// They can also be found in this file: https://cdn.cookielaw.org/scripttemplates/otSDKStub.js
export const EU_COUNTRIES = new Set([
    'BE',
    'BG',
    'CZ',
    'DK',
    'DE',
    'EE',
    'IE',
    'GR',
    'ES',
    'FR',
    'IT',
    'CY',
    'LV',
    'LT',
    'LU',
    'HU',
    'MT',
    'NL',
    'AT',
    'PL',
    'PT',
    'RO',
    'SI',
    'SK',
    'FI',
    'SE',
    'GB',
    'HR',
    'LI',
    'NO',
    'IS',
]);
export const OPT_IN_REGIONS = EU_COUNTRIES;
export const OPT_OUT_REGIONS = new Set(['US', 'CA']);
//# sourceMappingURL=countries.js.map